export const OutlookCalendarState = _ => ({
  calendarInfo: {},
})
